/* Zoss — vídeos de clientes (UGC): autoplay mudo só na tela, no máximo 2 tocando, modal com som. */
(function () {
  'use strict';

  var MAX_PLAYING = 2;
  var PLAY_RATIO = 0.6;

  function quietPlay(video) {
    var p = video.play();
    if (p && p.catch) p.catch(function () {});
    return p;
  }

  /* HLS adaptativo onde o navegador toca nativo (Safari/iOS); senão, mp4. */
  var canHls = (function () {
    var v = document.createElement('video');
    return !!(v.canPlayType && v.canPlayType('application/vnd.apple.mpegurl'));
  })();

  function sourceFor(card) {
    return (canHls && card.getAttribute('data-src-hls')) || card.getAttribute('data-src');
  }

  function init(root) {
    if (!root || root.hasAttribute('data-zs-ugc-ready')) return;
    root.setAttribute('data-zs-ugc-ready', '');

    var list = root.querySelector('.zs-ugc__list');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-zs-ugc-card]'));
    if (!cards.length) return;

    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var saveData = navigator.connection && navigator.connection.saveData;
    var autoplay = !reduceMotion && !saveData && 'IntersectionObserver' in window;

    var sectionNear = false;
    var modalOpen = false;
    var ratios = new Map();

    function cardVideo(card) { return card.querySelector('video'); }

    /* Só coloca o src quando a section está perto da tela E o card está perto da área visível do carrossel. */
    function arm(card) {
      var v = cardVideo(card);
      if (v.getAttribute('src') || !sectionNear || !card._zsNear) return;
      v.src = sourceFor(card);
    }

    /* Toca os (até) 2 cards mais visíveis e pausa o resto. */
    function syncPlayback() {
      if (!autoplay) return;
      var visible = cards
        .filter(function (c) { return (ratios.get(c) || 0) >= PLAY_RATIO; })
        .sort(function (a, b) { return ratios.get(b) - ratios.get(a); })
        .slice(0, MAX_PLAYING);

      cards.forEach(function (card) {
        var v = cardVideo(card);
        if (!modalOpen && visible.indexOf(card) !== -1) {
          arm(card);
          if (v.getAttribute('src') && v.paused) quietPlay(v);
        } else if (!v.paused) {
          v.pause();
        }
      });
    }

    if (autoplay) {
      new IntersectionObserver(function (entries) {
        sectionNear = entries[entries.length - 1].isIntersecting;
        if (sectionNear) cards.forEach(arm);
      }, { rootMargin: '400px 0px' }).observe(root);

      var nearObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          e.target._zsNear = e.isIntersecting;
          arm(e.target);
        });
      }, { root: list, rootMargin: '0px 50% 0px 50%' });

      var playObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { ratios.set(e.target, e.isIntersecting ? e.intersectionRatio : 0); });
        syncPlayback();
      }, { threshold: [0, 0.3, PLAY_RATIO, 0.8, 1] });

      cards.forEach(function (card) {
        nearObserver.observe(card);
        playObserver.observe(card);
      });
    }

    /* ---------- Modal ---------- */
    var modal = root.querySelector('[data-zs-ugc-modal]');
    var mv = root.querySelector('[data-zs-ugc-modal-video]');
    var soundBtn = root.querySelector('[data-zs-ugc-sound]');
    var countEl = root.querySelector('[data-zs-ugc-count]');
    var current = 0;
    var muted = false;
    var lastFocus = null;

    function setMuted(value) {
      muted = value;
      mv.muted = value;
      soundBtn.setAttribute('aria-pressed', value ? 'true' : 'false');
      soundBtn.setAttribute('aria-label', value ? 'Ligar o som' : 'Tirar o som');
    }

    function show(index) {
      current = (index + cards.length) % cards.length;
      var card = cards[current];
      mv.poster = card.getAttribute('data-poster-full');
      mv.src = sourceFor(card);
      mv.muted = muted;
      /* Chamado dentro do clique/toque: iOS e Android liberam o som. Se o navegador
         ainda assim bloquear, cai para mudo e o botão de som fica disponível. */
      var p = mv.play();
      if (p && p.catch) {
        p.catch(function (err) {
          if (err && err.name === 'NotAllowedError' && !mv.muted) {
            setMuted(true);
            quietPlay(mv);
          }
        });
      }
      if (countEl) countEl.textContent = (current + 1) + ' / ' + cards.length;
    }

    function open(index) {
      modalOpen = true;
      lastFocus = document.activeElement;
      cards.forEach(function (c) { var v = cardVideo(c); if (!v.paused) v.pause(); });
      if (typeof modal.showModal === 'function') modal.showModal();
      else modal.setAttribute('open', '');
      document.body.classList.add('zs-locked');
      show(index);
    }

    function cleanup() {
      if (!modalOpen) return;
      modalOpen = false;
      mv.pause();
      mv.removeAttribute('src');
      mv.load();
      document.body.classList.remove('zs-locked');
      syncPlayback();
    }

    function close(restoreFocus) {
      if (modal.open) {
        if (typeof modal.close === 'function') modal.close();
        else modal.removeAttribute('open');
      }
      cleanup();
      if (restoreFocus !== false && lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    }

    cards.forEach(function (card, i) {
      card.addEventListener('click', function () { open(i); });
    });

    root.querySelector('[data-zs-ugc-close]').addEventListener('click', function () { close(); });

    var prev = root.querySelector('[data-zs-ugc-prev]');
    var next = root.querySelector('[data-zs-ugc-next]');
    if (prev) prev.addEventListener('click', function () { show(current - 1); });
    if (next) next.addEventListener('click', function () { show(current + 1); });

    soundBtn.addEventListener('click', function () {
      setMuted(!muted);
      if (mv.paused) quietPlay(mv);
    });

    mv.addEventListener('click', function () {
      if (mv.paused) quietPlay(mv);
      else mv.pause();
    });

    /* ESC dispara "cancel" no <dialog>; o "close" cobre qualquer outro fechamento. */
    modal.addEventListener('cancel', function (e) { e.preventDefault(); close(); });
    modal.addEventListener('close', cleanup);

    modal.addEventListener('keydown', function (e) {
      if (cards.length < 2) return;
      if (e.key === 'ArrowRight') { e.preventDefault(); show(current + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); show(current - 1); }
    });

    /* Swipe horizontal no mobile. */
    var touchX = null;
    var touchY = null;
    modal.addEventListener('touchstart', function (e) {
      touchX = e.touches[0].clientX;
      touchY = e.touches[0].clientY;
    }, { passive: true });
    modal.addEventListener('touchend', function (e) {
      if (touchX === null || cards.length < 2) return;
      var dx = e.changedTouches[0].clientX - touchX;
      var dy = e.changedTouches[0].clientY - touchY;
      touchX = null;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) show(current + (dx < 0 ? 1 : -1));
    }, { passive: true });

    /* "Comprar agora": fecha o modal e leva até o formulário de compra. */
    root.querySelector('[data-zs-ugc-buy]').addEventListener('click', function () {
      close(false);
      var form = document.querySelector('[data-zs-product-form]');
      if (!form) return;
      form.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
      var submit = form.querySelector('[type="submit"]');
      if (submit) submit.focus({ preventScroll: true });
    });
  }

  function initAll() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-zs-ugc]'), init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  /* Editor de tema: a section é re-renderizada ao mudar configurações. */
  document.addEventListener('shopify:section:load', initAll);
})();
